import { AppState } from "../store";

export const getUserAgent = (state: AppState) => state.userAgent;
